import dedent from 'ts-dedent';
import { ColumnDataType, Provider, WorkflowComponentParamType } from '../types';
import { SelectWorkflowComponent } from './common/selectcomponent';
const INSIDE_POLYGON = [
    'Return a distance of 0',
    'Return the distance to the nearest edge'
];
const M_TO_KM = 0.001;
const M_TO_MILES = 0.000621371;
const M_TO_FEET = 3.28084;
class DistanceSingleTable extends SelectWorkflowComponent {
    constructor() {
        super({
            name: 'alteryx.distance',
            group: 'Spatial Operations',
            title: 'Distance (single table)',
            description: `
      This component calculates the ellipsoidal direct point-to-point, point-to-edge, or the drive distance between two sets of spatial objects.
      `
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.InputTable,
                title: 'Source table'
            },
            {
                name: 'points',
                type: WorkflowComponentParamType.Column,
                title: 'Point or centroid source',
                parent: 'source',
                dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
            },
            {
                name: 'destination',
                type: WorkflowComponentParamType.Column,
                title: 'Point, line or polygon destination ',
                parent: 'source',
                dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
            },
            {
                name: 'insidepolygon',
                type: WorkflowComponentParamType.Selection,
                title: 'When a point is inside a polygon',
                options: INSIDE_POLYGON,
                default: INSIDE_POLYGON[0]
            },
            {
                name: 'createpoint',
                type: WorkflowComponentParamType.Boolean,
                title: 'Create nearest interior point inside of the polygon',
                default: false
            },
            {
                name: 'directiondegrees',
                type: WorkflowComponentParamType.Boolean,
                title: 'Output direction in degrees',
                default: false
            },
            {
                name: 'directioncardinal',
                type: WorkflowComponentParamType.Boolean,
                title: 'Output cardinal direction',
                default: false
            },
            {
                name: 'units',
                type: WorkflowComponentParamType.Selection,
                title: 'Units',
                options: ['Kilometers', 'Miles', 'Feet', 'Meters'],
                default: 'Kilometers'
            }
        ]);
        this.supportedProviders = [Provider.BigQuery];
    }
    getInnerSql({ params, connection }) {
        if (connection.type !== Provider.BigQuery) {
            return null;
        }
        let except = '';
        if (!params.createpoint) {
            except = 'EXCEPT (__nearest)';
        }
        let unitConversion = '';
        if (params.units === 'Miles') {
            unitConversion = `* ${M_TO_MILES}`;
        }
        else if (params.units === 'Feet') {
            unitConversion = `* ${M_TO_FEET}`;
        }
        else if (params.units === 'Kilometers') {
            unitConversion = `* ${M_TO_KM}`;
        }
        const directions = [];
        if (params.directiondegrees) {
            directions.push(`ST_AZIMUTH(${params.points}, __nearest) * 180 / 3.1415926535897931 AS direction_degrees`);
        }
        let functions = '';
        if (params.directioncardinal) {
            functions = `
      `;
            directions.push(`CASE FLOOR(
            (ST_AZIMUTH(${params.points}, __nearest) +
            3.1415926535897931 / 16) / 2 / 3.1415926535897931 * 8
          )
          WHEN 0 THEN 'less than 0'
          WHEN 1 THEN 'N'
          WHEN 2 THEN 'NE'
          WHEN 3 THEN 'E'
          WHEN 4 THEN 'SE'
          WHEN 5 THEN 'S'
          WHEN 6 THEN 'SW'
          WHEN 7 THEN 'W'
          WHEN 8 THEN 'NW'
          ELSE 'N'
        END AS direction_cardinal`);
        }
        let sDirections = '';
        if (directions.length) {
            sDirections = `, ${directions.join(', ')}`;
        }
        if (params.insidepolygon === INSIDE_POLYGON[0]) {
            return dedent `
      WITH nearest AS (
        SELECT ST_CLOSESTPOINT(${params.destination}, ${params.points}) __nearest, *
        FROM ${connection.quoteName(params.source)}
      )
      SELECT
        ST_DISTANCE(${params.points}, __nearest) ${unitConversion} AS distance_${params.units.toLowerCase()}
        ${sDirections}, * ${except}
      FROM nearest`;
        }
        else {
            //TODO
            return dedent `
      WITH nearest AS (
        SELECT ST_CLOSESTPOINT(${params.destination}, ${params.points}) __nearest, *
        FROM ${connection.quoteName(params.source)}
      )
      SELECT
        ST_DISTANCE(${params.points}, __nearest) ${unitConversion} AS distance_${params.units.toLowerCase()}
        ${sDirections}, * ${except}
      FROM nearest`;
        }
    }
}
export { DistanceSingleTable };
